

















































































































































































































































































































































































































































import {
  Component,
  PropSync,
  Prop,
  Watch,
  Vue,
  Ref,
} from "vue-property-decorator";
import RightDrawer from "@/components/misc/RightDrawer.vue";
import DateField, {
  formatCountOfNights,
} from "@/components/misc/DateField.vue";
import {
  formatLocaleNumber,
  parseLocaleNumber,
} from "@/components/numbers/numberFormatUtils";
import { ReservationAccUnitModel } from "./types";
import CurrencyDisplay from "@/components/misc/CurrencyDisplay.vue";
import { Action, Getter } from "vuex-class";
import { Currency } from "@/shared/models/currency";
import * as _ from "lodash";
import { JwtClaims } from "@/store/modules/auth";
import { policyChecker } from "@/shared/roles";
import TimeField from "@/components/misc/TimeField.vue";
import { isString, isNumber } from "lodash/fp";
import { Notification } from "@/store/modules/notifications";
import { ListModel } from "@/shared/models/listModel";
import { AddOnServiceModel } from "./types";
import { SalesChannelView } from "@/shared/models/salesChannel";
import { FinancialSettingsType } from "@/store/modules/financial";
import { ServiceType } from "@/shared/models/serviceType";
import { RatePlanModel } from "@/components/reservation-form/types";
import { differenceInDays } from "@/shared/dateFormatUtils";
import {
  CurrencyConversionService,
  currencyConversionServiceFactory,
} from "@/shared/currencyConversionService";
import { AppParam, AppParamsEnum } from "@/shared/models/appParam";
import TableCellUnitTypeDisplay from "../misc/TableCellUnitTypeDisplay.vue";
import { TenantTypesEnum } from "@/shared/models/enums.type";
import NumericInputImproved from "../numbers/NumericInputImproved.vue";
import { round } from "@/components/numbers/numberFormatUtils";

@Component({
  components: {
    RightDrawer,
    DateField,
    CurrencyDisplay,
    NumericInputImproved,
    TimeField,
    TableCellUnitTypeDisplay,
  },
})
export default class ReservationFormUnitForm extends Vue {
  fkey = 0;

  model: ReservationAccUnitModel = new ReservationAccUnitModel();
  initialUnit: ReservationAccUnitModel = new ReservationAccUnitModel();

  get unitCurrencyId() {
    return (
      this.model.ratePlan?.currencyId ??
      this.financialSettings?.workingCurrency.id
    );
  }

  get tenantUsesServiceType() {
    const param = this.appParams?.find(
      (x) => x.id == AppParamsEnum.ReservationTenantUsesServiceTypes
    );
    return param && param.value;
  }

  ratePlanId = 0;
  ratePlanAccUnitTypeId = 0;

  @Watch("open")
  async openWatch(fresh: boolean, old: boolean) {
    if (fresh && !old) {
      this.fkey++;

      if (this._unit) {
        this.model = _.cloneDeep(this._unit);
        this.ratePlanId = this.model.ratePlan?.id ?? 0;
        this.ratePlanAccUnitTypeId =
          this.model.ratePlan?.ratePlansAccomodationUnitTypeId ?? 0;
        if (
          this.channelCommissionPercent !== this._unit.channelCommissionPercent
        ) {
          this.channelCommissionPercent = this._unit.channelCommissionPercent; // forcing commission calculation for newly added units
        }
        this.model.arrivalDate = this.model.arrivalDate.substring(0, 10);
        this.model.departureDate = this.model.departureDate.substring(0, 10);
        this.initialUnit = _.cloneDeep(this.model);
      }
    }
  }

  @Getter("appParams/tenantUsesInputPrice") tenantUsesInputPrice?: boolean;
  get usesInputPrice() {
    return this.tenantUsesInputPrice ?? false;
  }

  @Getter("appParams/tenantUsesAgencyFees")
  tenantUsesAgencyFees?: boolean;

  @Getter("appParams/workingCurrency") workingCurrency?: Currency;
  currencyConversionService?: CurrencyConversionService;
  async created() {
    const promises = [];

    if (!this.financialSettings && this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    await Promise.all(promises);

    if (this.financialSettings) {
      this.currencyConversionService = currencyConversionServiceFactory(
        this.financialSettings
      );
    }
  }

  @Getter("auth/claims") claims?: JwtClaims;
  get canEditPrices() {
    return policyChecker("MODIFY_RESERVATION_PRICES")(this.claims);
  }

  loading = false;
  isFormValid = false;
  get submitDisabled(): boolean {
    return this.isFormValid && !this.loading;
  }

  @Ref("drawer") rightDrawer?: RightDrawer;

  close() {
    this.rightDrawer?.clickOverlay();
  }

  save() {
    if (this._unit) {
      const specificUnit = this.units.find(
        (x) => x.id == this.model.accomodationUnitId
      );

      this._unit.accomodationUnitId = this.model.accomodationUnitId;
      this._unit.ownerId = specificUnit?.ownerId ?? undefined;
      this._unit.accomodationUnitName = this.model.accomodationUnitName;
      this._unit.ratePlan = this.model.ratePlan
        ? { ...this.model.ratePlan }
        : undefined;
      this._unit.ratePlansAccomodationUnitTypeId =
        this.model.ratePlan?.ratePlansAccomodationUnitTypeId;
      this._unit.occupancyBasedRuleId = this.model.occupancyBasedRuleId;
      this._unit.allowedOccupancy = this.model.allowedOccupancy;
      this._unit.dayPrices = this.model.dayPrices;
      this._unit.pricePerNight = this.model.pricePerNight;
      this._unit.arrivalDate = this.model.arrivalDate;
      this._unit.departureDate = this.model.departureDate;
      this._unit.channelCommission = this.model.channelCommission;
      this._unit.channelCommissionPercent = this.model.channelCommissionPercent;
      this._unit.maintenanceStaffRemarks = this.model.maintenanceStaffRemarks;
      this._unit.manuallyChangedRatePlan = this.model.manuallyChangedRatePlan;
      this._unit.inputPriceWasManuallyChanged =
        this.model.inputPriceWasManuallyChanged;

      this.specialOfferServices.forEach((element) => {
        const common = this.model.selectedServices.find(
          (x) => x.addOnServiceId === element.addOnServiceId
        );
        if (common === undefined) {
          this.model.selectedServices.push(element);
        }
      });

      this._unit.selectedServices = this.model.selectedServices;

      this.$emit("saved");
    }

    this.$emit("update:open", false);
  }

  get channelCommission() {
    return this.model?.channelCommission || 0;
  }
  set channelCommission(value: number | null) {
    if (this.model) {
      const normalizedValue = value ? value : 0;
      this.model.channelCommission = +normalizedValue;

      const servicePriceWithoutTax = this.model.selectedServices
        .filter((s) => !s.isCityTax)
        .reduce((acc, s) => acc + s.grossPrice, 0);
      const baseAmount = this.totalPrice + servicePriceWithoutTax;

      this.model.channelCommissionPercent = round(
        (normalizedValue / baseAmount) * 100,
        6
      );
      this.channelCommissionPercent = this.model.channelCommissionPercent;
    }
  }

  get channelCommissionPercent() {
    return this.model?.channelCommissionPercent || 0;
  }
  set channelCommissionPercent(value: number | null) {
    if (this.model) {
      const normalizedValue = value || 0;

      const servicePriceWithoutTax = this.model.selectedServices
        .filter((s) => !s.isCityTax)
        .reduce((acc, s) => acc + s.grossPrice, 0);
      const baseAmount = this.totalPrice + servicePriceWithoutTax;

      this.model.channelCommission = round(
        baseAmount * (normalizedValue / 100)
      );

      this.calculateInputPrices();

      this.model.channelCommissionPercent = normalizedValue;
    }
  }

  calculateInputPrices() {
    // This is used to calculate new input price when channel commission percent changes but only if the input price was not manually changed.
    if (
      this.model?.ownerPaysOTACommission &&
      !this.model.inputPriceWasManuallyChanged
    ) {
      this.model.dayPrices.forEach((x) => {
        x.inputPrice = x.inputPriceBeforeCommission;
      });
    }
    // This is used to calculate new input price for new days when arrival/departure day changes and we have manually changed input price.
    else if (
      this.model?.ownerPaysOTACommission &&
      this.model.inputPriceWasManuallyChanged &&
      this.model.dayPrices.some(
        (x) => x.inputPrice === x.inputPriceBeforeCommission
      )
    ) {
      this.model.dayPrices
        .filter((dp) => dp.inputPrice === dp.inputPriceBeforeCommission)
        .forEach((x) => {
          x.inputPrice = x.inputPriceBeforeCommission;
        });
    }
  }

  @Watch("model.dayPrices")
  arrivalDateChanged(fresh: any[], old: any[]) {
    if (
      fresh.length !== old.length &&
      this.channelCommissionPercent !== this.model.channelCommissionPercent
    ) {
      // We are calling this set function because we need to recalculate channel commission and after that new input prices.
      this.channelCommissionPercent = this.model.channelCommissionPercent;
    }
  }

  get feeCalculationFactors() {
    return {
      comission: this.model?.channelCommission,
      totalPrice: this.totalPrice,
    };
  }

  get totalAgencyFeesWithOtaIfPaid() {
    return (
      (this.model.agencyFeesTotal ?? 0) +
      (this.model.ownerPaysOTACommission
        ? this.model.channelCommission ?? 0
        : 0)
    );
  }

  @Watch("feeCalculationFactors")
  recalculated(fresh: any, old?: any) {
    if (
      _.isEqual(fresh, old) ||
      old.comission === null ||
      old.totalPrice === null ||
      old.comission === undefined ||
      old.totalPrice === undefined
    ) {
      return;
    }
    this.$emit("recalculateAgencyFees", this.model);
  }

  clampPercentage() {
    if (this.model) {
      let normalizedValue = this.model?.channelCommissionPercent || 0;

      normalizedValue = normalizedValue < 0 ? 0 : normalizedValue;
      normalizedValue = normalizedValue > 99.9 ? 99.9 : normalizedValue;

      if (this.channelCommissionPercent != normalizedValue) {
        this.channelCommissionPercent = normalizedValue;
      }
    }
  }

  get nightsDisplay() {
    return formatCountOfNights(this)([
      this.model.arrivalDate?.substring(0, 10),
      this.model.departureDate?.substring(0, 10),
    ]);
  }

  get formTitle() {
    return this.initialUnit.propertyName.length +
      this.initialUnit.accomodationUnitTypeName.length >
      90
      ? this.initialUnit.accomodationUnitTypeName
      : [
          this.initialUnit.propertyName,
          " - ",
          this.initialUnit.accomodationUnitTypeName,
        ].join("");
  }

  get units() {
    return this.model?.accomodationUnitOptions || [];
  }

  get ratePlans() {
    const ratePlanOptions = this.model.ratePlanOptions.filter((x) => x.status);
    const numberOfGuests =
      this.model.numberOfAdults +
      (this.childrenAffectPAXRatePlanSelection
        ? this.model.numberOfChildren
        : 0);

    let options = [] as RatePlanModel[];

    options = ratePlanOptions.filter(
      (x) =>
        x.minStay <= this.numberOfNights &&
        (x.maxStay >= this.numberOfNights || x.maxStay === 0) &&
        x.minPersons <= numberOfGuests &&
        x.maxPersons >= numberOfGuests
    );

    options.push(
      ...ratePlanOptions.filter(
        (x) => x.isDefault && !options.some((e) => e.ratePlanId == x.ratePlanId)
      )
    );

    const standaloneRatePlans = options
      .filter((x) => !x.isDerived)
      .sort((a, b) => a.name.localeCompare(b.name));
    const derivedRatePlans = options
      .filter((x) => x.isDerived)
      .sort((a, b) => a.name.localeCompare(b.name));

    const sortedRatePlans: RatePlanModel[] = [];

    for (const standaloneRatePlan of standaloneRatePlans) {
      sortedRatePlans.push(standaloneRatePlan);

      const derivedRates = derivedRatePlans.filter(
        (x) => x.parentRatePlanId === standaloneRatePlan.ratePlanId
      );

      for (const derivedRate of derivedRates) {
        sortedRatePlans.push(derivedRate);
      }
    }

    return sortedRatePlans;
  }

  get stayPeriod() {
    return {
      arrivalDate: this.model.arrivalDate,
      departureDate: this.model.departureDate,
    };
  }

  get getDayPricesSortedByDate() {
    return this.model.dayPrices.sort((date1, date2) => {
      return (
        new Date(date1.date).setHours(0, 0, 0, 0) -
        new Date(date2.date).setHours(0, 0, 0, 0)
      );
    });
  }

  @Watch("stayPeriod")
  stayPeriodChanged(val: any, old: any) {
    if (!_.isEqual(val, old)) {
      this.getUnitDayPrices();
    }
  }

  // get day prices for units
  getUnitDayPrices() {
    if (this.model && this.model.arrivalDate && this.model.departureDate) {
      const requestModel = {
        arrivalDate: this.model.arrivalDate,
        departureDate: this.model.departureDate,
        accomodationUnitTypesIds: [this.model.accomodationUnitTypeId],
      };

      Vue.axios
        .post("reservations/GetUnitsDayPrices", requestModel)
        .then((res) => {
          if (this.model) {
            for (const ratePlan of this.model.ratePlanOptions) {
              const ratePlanPrices = res.data
                .find(
                  (x: any) =>
                    x.accomodationUnitTypeId ===
                    this.model.accomodationUnitTypeId
                )
                ?.ratePlanPrices.find(
                  (x: any) => x.ratePlanAccUnitTypeId === ratePlan.id
                );

              ratePlan.dayPrices =
                ratePlanPrices?.dayPrices.filter(
                  (x: any) =>
                    (Date.parse(x.date.toString().substring(0, 10)) >=
                      Date.parse(this.model.arrivalDate) &&
                      Date.parse(x.date.toString().substring(0, 10)) <
                        Date.parse(this.model.departureDate)) ||
                    (Date.parse(x.date.toString().substring(0, 10)) ==
                      Date.parse(this.model.arrivalDate) &&
                      Date.parse(x.date.toString().substring(0, 10)) ==
                        Date.parse(this.model.departureDate))
                ) ?? [];

              if (
                this.model.ratePlan?.ratePlansAccomodationUnitTypeId ===
                ratePlan.id
              ) {
                const currentPrices = _.cloneDeep(this.model.dayPrices);
                const isDayStay =
                  this.model.arrivalDate == this.model.departureDate;
                const isServiceTypeDayStay =
                  _.first(currentPrices)?.serviceTypeId ==
                  _.first(this.serviceTypes?.filter((x) => x.isDayRest))?.id;

                // set serviceType to one from current prices or to ratePlans default serviceType for new units
                const currentServiceTypeId =
                  isDayStay && !isServiceTypeDayStay
                    ? _.first(this.serviceTypes?.filter((x) => x.isDayRest))?.id
                    : !isDayStay && isServiceTypeDayStay
                    ? ratePlan.defaultServiceTypeId
                    : _.first(currentPrices)?.serviceTypeId ??
                      ratePlan.defaultServiceTypeId;

                const currentPriceIncludeCityTax =
                  this.serviceTypeIncludesCityTax(currentServiceTypeId ?? 0) ??
                  false;

                this.model.dayPrices = _.cloneDeep(ratePlan?.dayPrices ?? []);

                // if user has set pricePerNight manually we still need to fetch prices in case stay period was changed
                // after which we set all day prices to user set value
                if (this.model.userSetPricePerNightManually) {
                  this.model.dayPrices.forEach(
                    (x) => (
                      (x.serviceTypeId = currentServiceTypeId),
                      (x.price =
                        (this.model.pricePerNight ?? x.price) -
                        this.mergedCityTaxPricePerDay(
                          currentPriceIncludeCityTax
                        )),
                      (x.mergedCityTaxAmount = this.mergedCityTaxPricePerDay(
                        currentPriceIncludeCityTax
                      ))
                    )
                  );
                }
                // If none of the above is triggered we still need to
                // set new price and merged amount
                else {
                  this.model.dayPrices.forEach(
                    (x) => (
                      (x.serviceTypeId = currentServiceTypeId),
                      (x.price =
                        x.price -
                        this.mergedCityTaxPricePerDay(
                          currentPriceIncludeCityTax
                        )),
                      (x.mergedCityTaxAmount = this.mergedCityTaxPricePerDay(
                        currentPriceIncludeCityTax
                      )),
                      (x.serviceTypeId = currentServiceTypeId)
                    )
                  );
                }

                // only change unsaved prices (eg, when extending a stay for 1 day, only update the price for that 1 day)
                currentPrices.forEach((e: any) => {
                  e.serviceTypeId =
                    !isDayStay && isServiceTypeDayStay
                      ? currentServiceTypeId
                      : isDayStay && !isServiceTypeDayStay
                      ? currentServiceTypeId
                      : e.serviceTypeId;
                  e.price =
                    e.price +
                    e.mergedCityTaxAmount -
                    this.mergedCityTaxPricePerDay(currentPriceIncludeCityTax);
                  e.mergedCityTaxAmount = this.mergedCityTaxPricePerDay(
                    currentPriceIncludeCityTax
                  );
                });
                const pricesToSet: {
                  date: Date;
                  price: number;
                  inputPrice: number;
                  inputPriceBeforeCommission: number;
                  serviceTypeId?: number;
                  mergedCityTaxAmount: number;
                }[] = [];
                this.model.dayPrices.forEach((e: any) =>
                  pricesToSet.push(
                    currentPrices?.find((x) => x.date == e.date) ?? e
                  )
                );

                this.model.dayPrices = _.cloneDeep(pricesToSet);
                this.channelCommissionPercent =
                  this.model.channelCommissionPercent;

                this.model.pricePerNight = round(
                  round(
                    this.model.dayPrices.reduce(
                      (sum, dprice) =>
                        sum + dprice.price + dprice.mergedCityTaxAmount,
                      0
                    ) ?? 0
                  ) / (this.model.dayPrices.length ?? 1)
                );
              }
            }
          }
        });
    }
  }

  firstDayPriceServiceTypeIdChanged(index: number) {
    if (index == 0) {
      const freshIncludesCityTax = this.serviceTypes?.find(
        (x) => x.id == _.first(this.model.dayPrices)?.serviceTypeId
      )?.includesCityTax;
      const alreadyIncludesCityTax =
        (_.first(this.model.dayPrices)?.mergedCityTaxAmount ?? 0) > 0;
      const mergedCityTax = this.mergedCityTaxPricePerDay();
      if (freshIncludesCityTax == true && !alreadyIncludesCityTax) {
        this.model.dayPrices.forEach((x) => {
          x.price = x.price - mergedCityTax;
          x.mergedCityTaxAmount = mergedCityTax;
        });
      }
      if (freshIncludesCityTax == false && alreadyIncludesCityTax) {
        this.model.dayPrices.forEach((x) => {
          x.price = x.price + x.mergedCityTaxAmount;
          x.mergedCityTaxAmount = 0;
        });
      }
    }
  }

  dayPriceDisplay(dayPrice: any) {
    return round(dayPrice.price + this.mergedCityTaxPricePerDay());
  }

  priceForNightInput(val: number, dayPrice: any) {
    dayPrice.price = val - this.mergedCityTaxPricePerDay();
    if (this.model.userSetPricePerNightManually) {
      this.model.pricePerNight = this.averagePricePerNight;
    }
  }

  setAccUnit(unitId: number) {
    if (this.model) {
      const unit = this.units.find((x) => x.id == unitId);
      if (unit) {
        this.model.accomodationUnitName = unit.name;
      } else {
        this.model.accomodationUnitName = "";
      }
    }
  }

  setRatePlanEventHandler(
    ratePlanAccomodationUnitTypeId: number,
    editModel: ReservationAccUnitModel,
    autoSave: boolean
  ) {
    if (
      editModel.ratePlan?.ratePlansAccomodationUnitTypeId !==
      ratePlanAccomodationUnitTypeId
    ) {
      editModel.manuallyChangedRatePlan = true;
    }
    this.setRatePlan(ratePlanAccomodationUnitTypeId, editModel, autoSave);
  }

  setRatePlan(
    ratePlanAccomodationUnitTypeId: number,
    editModel: ReservationAccUnitModel,
    autoSave: boolean,
    isMulti = false,
    specialOfferServices: AddOnServiceModel[] | null = null,
    autoPriceRecalculation = false,
    inputPriceRecalculationOnly = false
  ) {
    const plan = editModel.ratePlanOptions.find(
      (x) => x.id == ratePlanAccomodationUnitTypeId
    );
    if (editModel) {
      editModel.ratePlan = plan
        ? {
            id: plan.ratePlanId,
            ratePlansAccomodationUnitTypeId: plan.id,
            name: plan.name,
            parentRatePlanId: plan.parentRatePlanId,
            currencyId: plan.currencyId,
            isDefault: plan.isDefault,
            minStay: plan.minStay,
            maxStay: plan.maxStay,
            minPersons: plan.minPersons,
            maxPersons: plan.maxPersons,
            losCategoryId: plan.losCategoryId,
            paxCategoryId: plan.paxCategoryId,
            accomodationBookingFee: plan.accomodationBookingFee,
            addOnServicesBookingFee: plan.addOnServicesBookingFee,
            mergeAllBookingFeesIntoSingleItem:
              plan.mergeAllBookingFeesIntoSingleItem,
          }
        : undefined;
    }

    editModel.occupancyBasedRuleId = undefined;
    editModel.allowedOccupancy = editModel.maxOccupancy;

    if (autoSave) {
      this.setSpecialOfferServices(
        ratePlanAccomodationUnitTypeId,
        editModel,
        specialOfferServices
      );
    } else {
      this.setSpecialOfferServices(
        ratePlanAccomodationUnitTypeId,
        null,
        specialOfferServices
      );
    }

    if (!isMulti && !autoPriceRecalculation) {
      this.$store.dispatch("showNotification", {
        color: "warning",
        timeout: 30000,
        message: this.$t("Reservation.RecalculatePrices"),
        actions: [
          {
            text: this.$t("Yes"),
            fun: async () => {
              await this.recalculatePrices(
                ratePlanAccomodationUnitTypeId,
                editModel,
                inputPriceRecalculationOnly
              );
              if (autoSave) {
                this.$emit("saved");
              }
              return true;
            },
          },
          {
            text: this.$t("No"),
            fun: () => {
              if (autoSave) {
                this.$emit("saved");
              }
              return true;
            },
          },
        ],
      } as Notification);
    } else if (autoPriceRecalculation) {
      this.recalculatePrices(
        ratePlanAccomodationUnitTypeId,
        editModel,
        inputPriceRecalculationOnly
      );
      if (autoSave) {
        this.$emit("saved");
      }
    }
  }

  async recalculatePrices(
    ratePlanAccomodationUnitTypeId: number,
    editModel: ReservationAccUnitModel,
    inputPriceRecalculationOnly: boolean
  ) {
    if (editModel) {
      const plan = editModel.ratePlanOptions.find(
        (x) => x.id === ratePlanAccomodationUnitTypeId
      );
      if (!editModel.userSetPricePerNightManually) {
        this.model = editModel;
        editModel.dayPrices.forEach((e: any) => {
          const match = plan?.dayPrices?.find((x) => x.date == e.date);
          if (match) {
            if (!inputPriceRecalculationOnly) {
              e.price = match.price - this.mergedCityTaxPricePerDay();
              e.mergedCityTaxAmount = this.mergedCityTaxPricePerDay();
            }
            e.inputPrice = match.inputPrice;
          }
        });
        editModel.pricePerNight = round(
          round(
            editModel.dayPrices.reduce(
              (sum, dprice) => sum + dprice.price + dprice.mergedCityTaxAmount,
              0
            ) ?? 0
          ) / (editModel.dayPrices.length ?? 1)
        );

        this.channelCommissionPercent = this.model.channelCommissionPercent;
      }
    }
  }

  specialOfferServices: AddOnServiceModel[] = [];

  async setSpecialOfferServices(
    ratePlanAccomodationUnitTypeId: number,
    editModel: ReservationAccUnitModel | null,
    services: AddOnServiceModel[] | null = null
  ) {
    if (services === null) {
      const res = await Vue.axios.get<ListModel<AddOnServiceModel>>(
        `reservations/GetSpecialOfferServices/${ratePlanAccomodationUnitTypeId}`
      );
      res.data.result.forEach((x) => (x.decimalQuantity = x.defaultQuantity));
      this.specialOfferServices = res.data.result;
    } else {
      this.specialOfferServices = services;
    }

    if (editModel) {
      this.specialOfferServices.forEach((element) => {
        // mark the special offer services as added automatically for booking fees to apply properly
        element.isAddedAutomatically = true;

        const common = editModel.selectedServices.find(
          (x) => x.addOnServiceId === element.addOnServiceId
        );
        if (common === undefined) {
          editModel.selectedServices.push(element);
        } else {
          common.defaultQuantity = element.defaultQuantity;
          common.discountPercent = element.discountPercent;
          common.isIncludedInPrice = element.isIncludedInPrice;
        }
      });
    }
  }

  // includesCityTax is passed because new prices dont have a serviceType defined so we use current prices
  // its undefined when its used by UI elements that need current state
  mergedCityTaxPricePerDay(includesCityTax?: boolean) {
    let totalCityTaxPrice = 0;
    if (this.model && this.model.selectedServices) {
      totalCityTaxPrice = this.model.selectedServices
        .filter((x) => x.isCityTax)
        .reduce(
          (sum, e) =>
            includesCityTax ??
            this.serviceTypes?.find(
              (x) => x.id == _.first(this.model.dayPrices)?.serviceTypeId
            )?.includesCityTax === true
              ? sum +
                (this.currencyConversionService?.convertCurrency(
                  e.grossPrice,
                  e.currencyId,
                  this.unitCurrencyId ?? e.currencyId
                ) ?? e.grossPrice)
              : sum,
          0
        );
    }

    return round(
      totalCityTaxPrice / (this.numberOfNights > 0 ? this.numberOfNights : 1)
    );
  }

  get totalPrice() {
    let totalPrice = 0;
    if (this.model && this.model.dayPrices) {
      totalPrice = this.model.dayPrices.reduce(
        (sum, e) => sum + e.price + this.mergedCityTaxPricePerDay(),
        0
      );
    }

    if (this.model && this.model.discountPercent) {
      totalPrice = round(
        totalPrice * (1 - round(this.model.discountPercent / 100, 8))
      );
    }

    return totalPrice;
  }

  get agencyMarginAmount() {
    return this.totalPrice - this.totalOwnerPrice;
  }

  get agencyMarginPercentageNumber() {
    return formatLocaleNumber(
      round((this.agencyMarginAmount / this.totalPrice) * 100),
      2
    );
  }

  get totalPriceWithoutDiscount() {
    let totalPriceWithoutDiscount = 0;
    if (this.model && this.model.dayPrices) {
      totalPriceWithoutDiscount = this.model.dayPrices.reduce(
        (sum, e) => sum + e.price + this.mergedCityTaxPricePerDay(),
        0
      );
    }
    return totalPriceWithoutDiscount;
  }

  get totalPriceWithDiscount() {
    //this is the number used for absoulte agency fees calculation
    let totalPriceWithDiscount = this.totalPriceWithoutDiscount;
    if (this.model && this.model.discountPercent) {
      totalPriceWithDiscount = round(
        totalPriceWithDiscount * (1 - this.model.discountPercent / 100)
      );
    }
    return totalPriceWithDiscount;
  }

  get ownerPriceWithoutDiscountOrFee() {
    let ownerFeeWithoutDiscount = 0;
    if (this.model && this.model.dayPrices) {
      ownerFeeWithoutDiscount = this.model.dayPrices.reduce(
        (sum, e) => sum + e.inputPrice,
        0
      );
    }

    return ownerFeeWithoutDiscount;
  }

  get totalOwnerPrice() {
    let totalOwnerPrice = 0;
    if (this.model && this.model.dayPrices) {
      totalOwnerPrice = this.model.dayPrices.reduce(
        (sum, e) => sum + e.inputPrice + this.mergedCityTaxPricePerDay(),
        0
      );
    }
    if (this.model && this.model.discountInputPercent) {
      totalOwnerPrice = round(
        totalOwnerPrice * (1 - this.model.discountInputPercent / 100)
      );
    }
    if (this.model.ownerPaysOTACommission && this.channelCommission != null) {
      totalOwnerPrice = totalOwnerPrice - this.channelCommission;
    }
    if (this.model.agencyFeesTotal != null) {
      totalOwnerPrice = totalOwnerPrice - this.model.agencyFeesTotal;
    }
    return totalOwnerPrice;
  }

  get averagePricePerNight() {
    if (this.model && this.model.dayPrices) {
      return round(this.totalPrice / (this.model.dayPrices.length ?? 1));
    }
    return 0;
  }

  get averageInputPricePerNight() {
    if (this.model && this.model.dayPrices) {
      return round(this.totalOwnerPrice / (this.model.dayPrices.length ?? 1));
    }

    return 0;
  }

  get numberOfNights() {
    if (this.model?.arrivalDate && this.model?.departureDate) {
      const numberOfDays = differenceInDays(
        new Date(this.model.arrivalDate),
        new Date(this.model.departureDate)
      );
      return isFinite(numberOfDays) && numberOfDays > 0 ? numberOfDays : 1;
    } else {
      return 0;
    }
  }

  get rules() {
    return {
      required: (value: any) => !!value || this.$t("Validation.Required"),
      requiredAllowedZero: (value: string | number) =>
        !!value || value === 0 || this.$t("Validation.Required"),
      noNegativeNumbers: (value: string | number) =>
        value == null ||
        value == undefined ||
        (isNumber(value) && value >= 0) ||
        (isString(value) && parseLocaleNumber(value) >= 0) ||
        this.$t("Validation.MustBePositive"),
      maxLength: (max: number) => (v: string) =>
        !v ||
        v.length <= max ||
        this.$t("Validation.MaxLength", { count: max }),
    };
  }

  get isTenantAgency() {
    return this.tenantTypeId === TenantTypesEnum.Agency;
  }

  get currencyIsoCode() {
    const currency = this.currencies?.find((x) => x.id == this.unitCurrencyId);
    return (
      currency?.isoCode ??
      this.financialSettings?.workingCurrency.isoCode ??
      "EUR"
    );
  }

  inputPriceChanged(index: number) {
    const inputPriceBeforeCommission = this.model.ownerPaysOTACommission
      ? round(
          this.model.dayPrices[index].inputPrice +
            round((this.channelCommission ?? 0) / this.numberOfNights)
        )
      : this.model.dayPrices[index].inputPrice;
    this.model.dayPrices[index].inputPriceBeforeCommission =
      inputPriceBeforeCommission;
    this.model.inputPriceWasManuallyChanged = true;
  }

  serviceTypeRule(val: number) {
    return this.serviceTypeIncludesCityTax(
      _.first(this.model.dayPrices)?.serviceTypeId ?? 0
    ) === this.serviceTypeIncludesCityTax(val)
      ? []
      : this.$t("Validation.ServiceTypeCategory");
  }

  serviceTypeIncludesCityTax(id: number) {
    return this.serviceTypes?.find((x) => x.id == id)?.includesCityTax;
  }

  date(value: string) {
    return new Date(value);
  }

  timeOptions = Array.from(
    Array(48),
    (v, k) =>
      `${_.padStart(Math.floor(k / 2).toString(), 2, "0")}:${
        k % 2 ? "30" : "00"
      }:00`
  );
  agencyMarginPercentage(marginAmount: number, dayPrice: number) {
    return formatLocaleNumber((marginAmount / dayPrice) * 100, 2);
  }

  getRateName(rate: RatePlanModel) {
    const paxSuffix =
      rate.minPersons === rate.maxPersons
        ? `${rate.minPersons} pax`
        : `${rate.minPersons}-${rate.maxPersons} pax`;
    const losSuffix =
      rate.maxStay === 0
        ? `${rate.minStay}+ LOS`
        : rate.minStay === rate.maxStay
        ? `${rate.minStay} LOS`
        : `${rate.minStay}-${rate.maxStay} LOS`;

    return `${rate.name}, ${paxSuffix}, ${losSuffix}`;
  }

  @Prop({ default: false }) open!: boolean;
  @Prop() distributionChannelTypeId!: number | null;
  @Prop() serviceTypes?: ServiceType[];
  @PropSync("unit", { default: new ReservationAccUnitModel() })
  _unit?: ReservationAccUnitModel;

  @Prop({ default: true }) isEditingReservation?: boolean;

  @Getter("codebooks/salesChannels") salesChannels?: SalesChannelView[];
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;
  @Getter("financial/settings") financialSettings?: FinancialSettingsType;
  @Getter("appParams/appParams") appParams?: AppParam[];
  @Getter("appParams/reservationHideDeposit") reservationHideDeposit?: boolean;
  @Getter("codebooks/currencies") currencies?: Currency[];
  @Getter("appParams/tenantOBRsUseRelativePricing")
  tenantOBRsUseRelativePricing?: boolean;

  @Getter("appParams/childrenAffectPAXRatePlanSelection")
  childrenAffectPAXRatePlanSelection?: boolean;

  @Getter("appParams/typeId") tenantTypeId?: number;
}
